jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});

/* LB! use this code for "collection title" STARTS */
$(function(){

	function equalTitleHeight(){
		var max = 0;
		var $titles = $('.t4s-product-title a.is--href-replaced');
		$titles.css({
			height: '',
			display: 'block'
		});
		$titles.each(function(){
			max = Math.max(max, $(this).outerHeight());
		});
		console.log("Max Height =", max);
		$titles.height(max);
	}
	$(window).on('load', equalTitleHeight);
	$(window).on('resize', function(){
		$('.t4s-product-title a.is--href-replaced').css('height','');
		equalTitleHeight();
	});

});
/* LB! use this code for "collection title" ENDS */


/* LB! use this code for "cart-recommendation" STARTS */
$(function(){



    var productId = $('.gb-cart-first-podid').text().trim();

    if (!productId) {
        console.log("Product ID not found");
        return;
    }

    $.ajax({
        type: "GET",
        url: "/recommendations/products",
        data: {
            section_id: "product-recommendations",
            limit: 6,
            product_id: productId
        },
        success: function (html) {

            console.log("Recommendations loaded");
setTimeout(function () {             
            $(".lb-recommendation-main").html(html);


 $(".t4s-flicky-slider").each(function () {
        var $this = $(this);
        var options = {};

        if ($this.hasClass("flickityt4s-enabled")) {
            try {
                $this.flickityt4s("destroy");
            } catch (e) {}
        }

        var flickityData = $this.attr("data-flickityt4s-js");

        if (flickityData) {
            try {
                options = JSON.parse(flickityData);
            } catch (e) {}
        }

        $this.flickityt4s(options);
    });


          }, 2000);

        },
        error: function (xhr, status, error) {
            console.log("Recommendation error:", error);
            console.log(xhr.responseText);
        }
    });
   });



$(document).on('click', '.gb-common-recommendations', function (e) {

    e.preventDefault();
 
    var productId = $(this).attr('proid');

    console.log("Clicked recommendation:", this);
    console.log("Product ID:", productId);

    if (!productId) {
        console.log("Product ID missing");
        return;
    }

    productId = productId.trim();

    var url = "/recommendations/products?section_id=product-recommendations&limit=6&product_id=" + productId;

    console.log("Fetching:", url);

    fetch(url)
        .then(function(response) {

            console.log("Status:", response.status);

            if (!response.ok) {
                throw new Error("HTTP Error " + response.status);
            }

            return response.text();

        })
        .then(function(html) {

            console.log("Recommendation HTML:", html);

            $(".lb-recommendation-main").html(html);

            // Reinitialize Kalles Flickity slider
           setTimeout(function(){

                $(".t4s-flicky-slider").each(function () {

                    var $slider = $(this);

                    if ($slider.hasClass("flickityt4s-enabled")) {
                        try {
                            $slider.flickityt4s("destroy");
                        } catch(err){}
                    }

                    var options = {};

                    var data = $slider.attr("data-flickityt4s-js");

                    if(data){
                        try {
                            options = JSON.parse(data);
                        } catch(err){}
                    }

                    $slider.flickityt4s(options);

                });

           },1000);

        })
        .catch(function(error){

            console.error("Recommendation error:", error);

        });

});

/* LB! use this code for "cart-recommendation" ENDS */


